export default "__VITE_ASSET__17a90c23__"